import { View, Text, styled } from 'tamagui'
import type { ServerTier } from '@/types'
import { TIER_CONFIGS } from '@/mocks'

const BadgePill = styled(View, {
  borderRadius: '$borderRadiusFull',
  alignItems: 'center',
  justifyContent: 'center',
  variants: {
    badgeSize: {
      sm: { paddingHorizontal: 5, paddingVertical: 1 },
      md: { paddingHorizontal: 7, paddingVertical: 2 },
    },
  } as const,
  defaultVariants: {
    badgeSize: 'md',
  },
})

const BadgeLabel = styled(Text, {
  fontFamily: '$fontBody',
  fontWeight: '700',
  textTransform: 'uppercase',
  letterSpacing: 0.5,
  variants: {
    badgeSize: {
      sm: { fontSize: 9 },
      md: { fontSize: 11 },
    },
  } as const,
  defaultVariants: {
    badgeSize: 'md',
  },
})

interface TierBadgeProps {
  tier: ServerTier
  size?: 'sm' | 'md'
}

export function TierBadge({ tier, size = 'md' }: TierBadgeProps) {
  const config = TIER_CONFIGS[tier]
  return (
    <BadgePill badgeSize={size} backgroundColor={config.color}>
      <BadgeLabel badgeSize={size} color="$surface">
        {config.label}
      </BadgeLabel>
    </BadgePill>
  )
}
